import { render } from "./LeaderboardRow.vue?vue&type=template&id=1e893fe4&scoped=true"
import script from "./LeaderboardRow.vue?vue&type=script&lang=js"
export * from "./LeaderboardRow.vue?vue&type=script&lang=js"

import "./LeaderboardRow.vue?vue&type=style&index=0&id=1e893fe4&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e893fe4"]])

export default __exports__